@if (!store.currentQuestion()) {
  <!-- Fin du jeu -->
  @if (store.isEndgame()) {
    <div class="box pr-u-displayFlex pr-u-flexDirectionColumn pr-u-gap150 pr-u-textCenter">
      @if (store.score() === store.principles().size) {
        <div>
          <h2 class="pr-u-marginBlockEnd50">Quête terminée</h2>
          <h3>🏆 Bien joué, vous avez réussi !</h3>
        </div>
        <lu-tag [label]="`Score : ${store.score()} sur ${store.principles().size}`" palette="success" size="L">
        </lu-tag>
        <p>Veuillez vous rapprocher d'un conseiller Luccasien pour récupérer votre récompense.</p>
        <p>Vous pourrez également participer au tirage au sort pour une autre, qui sera légeeendaire !</p>
      } @else {
        <h2 class="pr-u-marginBlockEnd50">Quête terminée</h2>
        <lu-tag [label]="`Score : ${store.score()} sur ${store.principles().size}`" palette="warning" size="L">
        </lu-tag>
        <p>Veuillez vous rapprocher d'un conseiller Luccasien pour récupérer votre récompense.</p>
        <div>
          <button type="button" luButton="outlined" (click)="store.restartGame()">Recommencer le jeu</button>
        </div>
      }
    </div>
  }
  <!-- En attente d'une question -->
  @else {
    <div class="game-tag"></div>
    <div class="box pr-u-displayFlex pr-u-flexDirectionColumn pr-u-gap150 pr-u-textCenter">
      <h4>Scannez un objet magique (QR&nbsp;Code)</h4>
      <p>
        {{ store.availablePrinciples() }} question{{ store.availablePrinciples() | pluralize }} restante{{
          store.availablePrinciples() | pluralize
        }}
      </p>
    </div>
  }
}
